import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedLevelOne } from '../../commonSlice.js';
import PropTypes from "prop-types";

const DdDefaultLevelOne = (props) => {
   const dispatch = useDispatch();
  const offcanvasState = useSelector((state) => state.common?.offcanvasState);
  const selectedData = get(offcanvasState, "selectedData", []);

  const drillDownSelectionState = useSelector(
    (state) => state?.common?.drillDownSelectionState
  );
  const count = get(
    offcanvasState,
    `selectedData.${props.level.name}.count`,
    0
  );
  const onSelectLvlOne = (key) => {
    const selectedIssue=key;
    props.onIssueSlect && props.onIssueSlect(selectedIssue)
    selectedData.DdLevelOneBoxClick &&
      selectedData.customSummaryListCall(props.level.name, offcanvasState);
    dispatch(setSelectedLevelOne(props.level.name));
    

  };
  return (
    <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-2 flow_box_Responcive">
      <div
        className={`${props.level.className} ${
          selectedData.opsMetricsCustomDrillDown ? count > 0
            ? "vaild"
            : "disabled" : ""
        } ${
          drillDownSelectionState?.selectedLevelOne === props?.level?.name
            ? "active"
            : ""
        }`}
        key={props.level.name}
        onClick={ () =>{ if ( drillDownSelectionState?.selectedLevelOne === props?.level?.name ) {return;}
                          onSelectLvlOne(props.level.name);
                        }}
      >
        {!selectedData.customBoxHeaders && <h4>{props?.level?.title}</h4>}
        {selectedData.customBoxHeaders ? (
          selectedData.customBoxHeaders(
            selectedData[props?.level?.name],
            props.level.title
          )
        ) : (
          <h2 className="fdcount">{count} </h2>
        )}
      </div>
    </div>
  );
};
export default DdDefaultLevelOne;
DdDefaultLevelOne.propTypes = {
  level: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
  }).isRequired,
  onIssueSlect: PropTypes.func,
};


